// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-tittle {\n  font-size: x-large;\n}\n\n.cardPrice {\n  display: flex;\n}", "",{"version":3,"sources":["webpack://./src/app/components/pagar-c/pagar-c.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AAEA;EACE,aAAA;AACF","sourcesContent":["ion-tittle{\n font-size: x-large;\n\n}\n.cardPrice{\n  display: flex;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
